export default "__VITE_ASSET__BUA8Vm5u__"